var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45635 1.48098L4.71648 9.22379C4.92545 9.7201 4.92545 10.2797 4.71648 10.776L1.45635 18.5188L20.2877 9.9999L1.45635 1.48098ZM0.706837 0.0443502L21.7068 9.54435C22.0987 9.72163 22.0987 10.2782 21.7068 10.4555L0.706837 19.9555C0.292591 20.1429 -0.1365 19.7249 0.039935 19.3059L3.79485 10.388C3.89933 10.1398 3.89933 9.86 3.79485 9.61185L0.039935 0.693933C-0.1365 0.274901 0.292591 -0.143047 0.706837 0.0443502Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00073 10.5V9.5H20.5007V10.5H4.00073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSend);
export default __webpack_public_path__ + "static/media/mail-send.bcbf436bf8e0c8e6ab35f2603885b71e.svg";
export { ForwardRef as ReactComponent };